import React from "react";
import { Flex, Text, Button } from "@jsq/ds/core";
import { Colors } from "@jsq/ds/styles";
import { FileWithType } from "../../../types";
import * as uploadStyles from "../styles_vanilla.css";

interface ActionButtonsProps {
  filesWithTypes: FileWithType[];
  allFilesHaveDataTypes: boolean;
  onNext: () => void;
  isUploading?: boolean;
  hasExistingFiles?: boolean;
}

const ActionButtons: React.FC<ActionButtonsProps> = ({
  filesWithTypes,
  allFilesHaveDataTypes,
  onNext,
  isUploading = false,
  hasExistingFiles = false,
}) => {
  if (hasExistingFiles) {
    return null;
  }

  if (filesWithTypes.length === 0) {
    return (
      <Text
        variant="regular-md"
        color={Colors.Neutral600}
        className={uploadStyles.uploadFilesText}
      >
        Upload files to get started
      </Text>
    );
  }

  return (
    <Flex justifyContent="flex-end" className={uploadStyles.buttonContainer}>
      <Button
        variant="primary"
        className={uploadStyles.primaryBlackButton}
        disabled={!allFilesHaveDataTypes || isUploading}
        onClick={onNext}
        isLoading={isUploading}
      >
        {isUploading ? "Uploading files..." : "Next: Validate Data"}
      </Button>
    </Flex>
  );
};

export default ActionButtons;
